import styled from 'styled-components'

export const SliderWrapper = styled.div`
  width: 100%;
  margin: 0;
  padding: 0;
  position: relative;
  z-index: 1;
`
export const PlaybarWrapper = styled.span`
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: ${({ $isDesktop }) => ($isDesktop ? '16px 24px' : '16px')};
  background-color: ${({ theme }) => theme.colors.neutralW20};
  position: relative;
`

export const ReleaseDetailsWrapper = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
`

export const CoverArt = styled.img`
  width: ${({ $isMobile }) => ($isMobile ? '40px' : '64px')};
  height: ${({ $isMobile }) => ($isMobile ? '40px' : '64px')};
  border-radius: 5px;
`

export const ReleaseWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`

export const ReleaseTitle = styled.span`
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 4px;
  padding-right: 10px;
  color: ${({ theme }) => theme.colors.neutralW100};
`

export const ReleaseArtist = styled.span`
  font-size: 14px;
  padding-right: 10px;
  color: ${({ theme }) => theme.colors.neutralW70};
`
export const PlayerDetailsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
`

export const PlayOptionsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ $isDesktop }) => ($isDesktop ? '16px' : '8px')};
`

export const SkipPreviousIcon = styled.div`
  display: flex;
  width: 40px;
  height: 40px;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  border-radius: 50%;
  cursor: ${({ $hasNoSong, $isFirstSong }) =>
    $hasNoSong || $isFirstSong ? 'default' : 'pointer'};

  ${({ $hasNoSong, $isFirstSong, theme }) =>
    !$hasNoSong &&
    !$isFirstSong &&
    `
    &:hover {
      background-color: ${theme.colors.neutralW30};
    }
  `}
`

export const SkipNextIcon = styled.div`
  display: flex;
  width: 40px;
  height: 40px;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  border-radius: 50%;
  cursor: ${({ $hasNoSong, $isLastSong }) =>
    $hasNoSong || $isLastSong ? 'default' : 'pointer'};

  ${({ $hasNoSong, $isLastSong, theme }) =>
    !$hasNoSong &&
    !$isLastSong &&
    `
      &:hover {
        background-color: ${theme.colors.neutralW30};
      }
    `}
`

export const PlayerIconWrapper = styled.div`
  display: flex;
  width: 40px;
  height: 40px;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  border-radius: 50%;
  cursor: ${({ $hasNoSong }) => ($hasNoSong ? 'default' : 'pointer')};
  background-color: ${({ theme, $hasNoSong }) =>
    $hasNoSong ? theme.colors.neutralW40 : theme.colors.neutralW100};

  ${({ $hasNoSong, theme }) =>
    !$hasNoSong &&
    `
      &:hover {
        background-color: ${theme.colors.neutralW80};
      }
    `}
`

export const IconContainer = styled.button`
  display: flex;
  width: 50px;
  height: 50px;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  border-radius: 50%;

  &:focus-visible {
    padding: 4px;
    outline: none;
    border: ${({ theme }) => `2px solid ${theme.colors.interact70}`};
  }
`

export const OptionsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ $isDesktop }) => ($isDesktop ? '16px' : '8px')};
  cursor: ${({ $hasNoSong }) => ($hasNoSong ? 'default' : 'pointer')};
`

export const IconWrapper = styled.button`
  display: flex;
  width: 30px;
  height: 30px;
  align-items: center;
  justify-content: center;
  transition: background-color 0.25s, border-color 0.25s;
  border-radius: 50%;
  cursor: ${({ $hasNoSong }) =>
    $hasNoSong ? 'default' : 'pointer'} !important;

  svg {
    width: 18px;
  }

  ${({ $hasNoSong, theme }) =>
    !$hasNoSong &&
    `
      &:hover {
        background-color: ${theme.colors.neutralW30};
      }
    `}

  &:focus-visible {
    outline: none;
    border: ${({ theme }) => `2px solid ${theme.colors.interact70}`};
  }
`

export const VolumeSliderWrapper = styled.div`
  img {
    width: 30px;
  }

  button {
    width: 30px;
    height: 30px;

    &:focus {
      outline: none;
    }
  }

  input {
    &:focus {
      border: none;
    }
  }
  button:focus {
    border: none;
  }

  button:active {
    border: ${({ theme }) => `1px solid ${theme.colors.interact70}`};
  }
`

export const DurationWrapper = styled.div`
  display: flex;
  font-size: 12px;
  font-weight: 400;
  color: ${({ theme, $hasNoSong }) =>
    $hasNoSong ? theme.colors.neutralW40 : theme.colors.neutralW70};
`
export const Wrap = styled.div`
  margin: 0 8px;
`
export const ToggleContainer = styled.div`
  display: flex;
  align-self: center;
  padding-top: 5px;
  align-items: center;
  justify-content: center;

  input:checked + label {
    &:after {
      width: 15px !important;
      height: 15px !important;
      margin-left: 19px !important;
    }

    div {
      left: 18px !important;
      top: 1px;
    }
    &:hover {
      background-color: ${({ theme }) => `${theme.colors.player40}`};
    }
  }

  label {
    &:after {
      width: 15px;
      height: 15px;
      margin: 2px 0 3px 3px;
    }

    div {
      left: 2px !important;
      top: 1px;
    }
  }

  svg {
    width: 14px !important;
    height: 14px !important;
  }
`
